import { useState } from "react";
import { Button } from "@shared/ui/Button";
import { Type } from "@shared/ui/Type";
import { Notification } from "../../notifications.types";
import NotificationItemContainer from "../NotificationItem/NotificationItemContainer";

type Props = {
  notifications: Notification[];
  hasMore: boolean;
  unreadCount: number;
  onMarkAllAsRead: () => void;
  loadMore?: () => void;
  isRefetching: boolean;
};

export function NotificationList({
  notifications,
  hasMore,
  unreadCount,
  loadMore = () => {},
  onMarkAllAsRead,
  isRefetching,
}: Props) {
  const [expandedNotifications, setExpandedNotifications] = useState<number[]>(
    []
  );

  const handleExpandNotification = (notificationId: number) => {
    setExpandedNotifications([notificationId]);
  };

  const handleCollapseNotification = (notificationId: number) => {
    setExpandedNotifications((prev) =>
      prev.filter((id) => id !== notificationId)
    );
  };

  return (
    <>
      <div className="flex flex-col gap-4 max-w-3xl">
        <div className="flex flex-row items-center justify-between gap-4">
          <Type variant="h5">
            Recent Notifications{" "}
            {unreadCount > 0 ? `(${unreadCount} unread)` : ""}
          </Type>
          {unreadCount > 0 && (
            <Button
              variant="secondary"
              onClick={onMarkAllAsRead}
              disabled={unreadCount === 0}
            >
              Mark all as read
            </Button>
          )}
        </div>
        {notifications.length > 0 ? (
          <div className="flex flex-col border border-brand-800 rounded-md">
            {notifications.map((notification) => (
              <NotificationItemContainer
                key={notification.id}
                notification={notification}
                isRefetching={isRefetching}
                isExpanded={expandedNotifications.includes(notification.id)}
                isAnyExpanded={expandedNotifications.length > 0}
                onExpand={handleExpandNotification}
                onCollapse={handleCollapseNotification}
              />
            ))}
          </div>
        ) : (
          <Type variant="body2">No notifications yet.</Type>
        )}
      </div>

      {hasMore && (
        <div className="flex justify-center mt-4">
          <Button onClick={loadMore}>Load more</Button>
        </div>
      )}
    </>
  );
}

export default NotificationList;
